import { createFileRoute } from "@tanstack/react-router";
import AdminTrainingVirtualDetailPage from "@/pages/admin/lms/trainings-virtual/detail";
import { useLmsPermissions } from "@/pages/admin/lms";

export const Route = createFileRoute("/app/admin/lms/trainings-virtual/$trainingId")({
  component: RouteComponent,
});

function RouteComponent() {
  const { trainingId } = Route.useParams();
  const {
    userCanAssociateMaterialsAndCriteria,
    userCanAssociateMaterialsAndTags,
    userCanAssociateMaterialsAndUserFunctions,
    userCanEditAllMaterials,
    userCanViewAllCriteria,
    userCanViewAllMaterials,
    userCanViewAllSettingTags,
    userCanViewAllTags,
  } = useLmsPermissions();

  return (
    <AdminTrainingVirtualDetailPage
      id={Number(trainingId)}
      userCanAssociateMaterialsAndCriteria={userCanAssociateMaterialsAndCriteria}
      userCanAssociateMaterialsAndTags={userCanAssociateMaterialsAndTags}
      userCanAssociateMaterialsAndUserFunctions={userCanAssociateMaterialsAndUserFunctions}
      userCanEditAllMaterials={userCanEditAllMaterials}
      userCanViewAllCriteria={userCanViewAllCriteria}
      userCanViewAllMaterials={userCanViewAllMaterials}
      userCanViewAllSettingTags={userCanViewAllSettingTags}
      userCanViewAllTags={userCanViewAllTags}
    />
  );
}
